import SiteHeader from '../components/SiteHeader';
import demoJobs from '../data/demoJobs.json';

const KPIS = [
  { label: 'Jobs this week', value: '24', hint: 'Sample metrics' },
  { label: 'Completed', value: '19', hint: '79% success' },
  { label: 'Avg. runtime', value: '1m 48s', hint: 'Sample runs' },
  { label: 'Custom models', value: '4', hint: 'Published' },
];

const CHART_BARS = [
  { label: 'Mon', value: 42 },
  { label: 'Tue', value: 68 },
  { label: 'Wed', value: 55 },
  { label: 'Thu', value: 80 },
  { label: 'Fri', value: 62 },
  { label: 'Sat', value: 28 },
  { label: 'Sun', value: 18 },
];

const GAUGE = { label: 'Mean parcel area (ha)', value: 12.4, min: 0, max: 40 };

export default function DashboardPage() {
  const recent = demoJobs.filter((j) => j.status === 'completed').slice(0, 3);
  const gaugePct = Math.min(100, Math.round((GAUGE.value / GAUGE.max) * 100));

  return (
    <div className="site-page site-page-app">
      <SiteHeader variant="app" />
      <div className="demo-banner">
        Sample analytics dashboard — charts and KPIs are illustrative only.
      </div>

      <main className="demo-page">
        <header className="demo-page-head">
          <div>
            <h1>Dashboard</h1>
            <p className="field-hint">
              Overview of processing activity. Real installs materialize results from QGIS job outputs.
            </p>
          </div>
          <div className="qgis-powered-chip">
            <img src="/qgis-logo.svg" alt="QGIS" width="22" height="22" />
            <span>Powered by QGIS</span>
          </div>
        </header>

        <section className="kpi-row">
          {KPIS.map((kpi) => (
            <article key={kpi.label} className="kpi-card panel-card">
              <span className="kpi-value">{kpi.value}</span>
              <span className="kpi-label">{kpi.label}</span>
              <span className="kpi-hint">{kpi.hint}</span>
            </article>
          ))}
        </section>

        <div className="dashboard-grid">
          <article className="panel-card dash-card">
            <h2>Jobs per day</h2>
            <div className="bar-chart" role="img" aria-label="Bar chart of jobs per day">
              {CHART_BARS.map((bar) => (
                <div key={bar.label} className="bar-chart-col">
                  <div className="bar-chart-track">
                    <div className="bar-chart-fill" style={{ height: `${bar.value}%` }} />
                  </div>
                  <span>{bar.label}</span>
                </div>
              ))}
            </div>
          </article>

          <article className="panel-card dash-card">
            <h2>{GAUGE.label}</h2>
            <div className="gauge-demo">
              <div className="gauge-ring" style={{ '--gauge-pct': `${gaugePct}%` }}>
                <div className="gauge-inner">
                  <strong>{GAUGE.value}</strong>
                  <span>ha</span>
                </div>
              </div>
              <p className="field-hint">From sample zonal / parcel aggregates</p>
            </div>
          </article>

          <article className="panel-card dash-card dash-card-wide">
            <h2>Recent completed jobs</h2>
            <ul className="dash-job-list">
              {recent.map((job) => (
                <li key={job.id}>
                  <div>
                    <strong>{job.name}</strong>
                    <span>{job.features != null ? `${job.features} features` : '—'}</span>
                  </div>
                  <span className="status-badge status-completed">completed</span>
                </li>
              ))}
            </ul>
          </article>
        </div>
      </main>
    </div>
  );
}
